import { BannerPrice, BannerPriceParams } from '../typings/banners';
import { CellKeyFieldsPartial } from '../typings/common';
import { BannerStatus } from '../typings/domain';

/* Изменение цены в гридах(единичное редактирование)*/
export const UPDATE_GRID_BANNER_PRICE_CELL = 'UPDATE_GRID_BANNER_PRICE_CELL';
export type UPDATE_GRID_BANNER_PRICE_CELL = typeof UPDATE_GRID_BANNER_PRICE_CELL;

export interface UpdateGridBannerPriceCell {
    type: UPDATE_GRID_BANNER_PRICE_CELL;
    params: BannerPriceParams;
    cellKeyPartial: CellKeyFieldsPartial;
}

export function updateGridBannerPriceCell(params: BannerPriceParams, columnName?: string): UpdateGridBannerPriceCell {
    return {
        type: UPDATE_GRID_BANNER_PRICE_CELL,
        params,
        cellKeyPartial: {
            id: params.bannerId,
            column: columnName
        }
    };
}

/* Обновление ячейки цен в гридах(единичное редактирование) */
export const UPDATE_GRID_BANNER_PRICE = 'UPDATE_GRID_BANNER_PRICE';
export type UPDATE_GRID_BANNER_PRICE = typeof UPDATE_GRID_BANNER_PRICE;

export interface UpdateGridBannerPrice {
    type: UPDATE_GRID_BANNER_PRICE;
    bannerId: string;
    bannerPrice: BannerPrice;
    status: BannerStatus | undefined;
}

export function updateGridBannerPrice(
    params: BannerPriceParams,
    status: BannerStatus | undefined
): UpdateGridBannerPrice {
    const { bannerId, bannerPrice } = params;

    return {
        type: UPDATE_GRID_BANNER_PRICE,
        bannerId,
        bannerPrice,
        status
    };
}

export type BannerGridAction = UpdateGridBannerPriceCell | UpdateGridBannerPrice;
